@let video = data();
<div class="cmp-vi<>d</>eo" [style.--ratio]="ratio()">
  @if (video.videoId) {
    @switch (video.type) {
      @case ('vimeo') {
        <pai-lazy-vimeo [videoId]="video.videoId" class="cmp-video__video" />
      }
      @case ('youtube') {
        <pai-lazy-youtube [videoId]="video.videoId" class="cmp-video__video" />
      }
    }
  }
  @if (video.caption) {
    <p class="cmp-video__caption">{{ video.caption }}</p>
  }
</div>
